import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalHeader } from "reactstrap";
import { StyledH2 } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";

import { deviceStore, setIsConfigurationPrinterClicked } from "../store";
import { resetStore } from "./General/Hook/store";
import { resetStore as resetStoreCustomer } from "./CustomerTicket/Hook/store";
import { resetStore as resetStoreKitchenTicket } from "./KitchenTicket/Hook/store";
import { resetStore as resetStoreDivers } from "./Divers/Hook/store";
import { resetStore as resetStoreModelTicket } from "./ModeleTicket/store";
import { useFetchGlobal } from "../../../../../api/hooks";
import { store as userStore } from "@components/VerticalLayout/store";

import { capitalize } from "@helpers/general";
import ErrorToast from "@components/Common/ErrorTost";

import { MenuWrapper } from "./MenuWrapperConfiguration";
import { setSalesModes } from "./store";
import { buildSalesModes, SalesModeApiItem } from "./salesModesHelper";

import "@assets/swal.css";
import "@assets/theme.css";
import "./index.css";
import { PrinterFooter } from "./PrinterFooter";

type PrinterRowData = Record<string, unknown> & { shopId?: string };

type ModeOfSaleResponse = {
    data?: SalesModeApiItem[];
};

type ConfigurationPrinterType = {
    rowData: PrinterRowData;
    oneShop: boolean;
    setDataIsUpdated: (value: boolean | number) => void;
    isDataUpdated: number | boolean;
};

export default function PrinterSetting({
    rowData,
    oneShop,
    setDataIsUpdated,
    isDataUpdated,
}: ConfigurationPrinterType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const { userID, franchiseID, shopID } = useSnapshot(userStore);
    const shopId = oneShop ? shopID : rowData.shopId;
    const { isConfigurationPrinterClicked } = useSnapshot(deviceStore);
    const [rawSalesModes, setRawSalesModes] = React.useState<
        SalesModeApiItem[]
    >([]);
    const fetchModeOfSale = React.useCallback(async () => {
        try {
            const response = await fetchGlobal<ModeOfSaleResponse>(
                `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_sale?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = response.data || [];
            setRawSalesModes(data);
            setSalesModes(buildSalesModes(data, rowData));
        } catch {
            ErrorToast(`${t("There's an error")!}`);
        }
        // eslint-disable-next-line
    }, [franchiseID, shopId, userID, rowData]);
    React.useEffect(() => {
        fetchModeOfSale();
    }, [fetchModeOfSale]);
    return (
        <Modal
            centered
            backdrop="static"
            fade={false}
            scrollable
            className="modal-wrapper-width__clz"
            isOpen={isConfigurationPrinterClicked}
        >
            <ModalHeader
                toggle={() => {
                    setIsConfigurationPrinterClicked!(
                        !isConfigurationPrinterClicked
                    );
                    resetStore();
                    resetStoreCustomer();
                    resetStoreKitchenTicket();
                    resetStoreDivers();
                    resetStoreModelTicket();
                    setSalesModes({});
                    setRawSalesModes([]);
                }}
            >
                <StyledH2>
                    {capitalize(t("Settings"))}{" "}
                    {rowData["applicationDesignation"]} -{" "}
                    {rowData[t("Peripheral")]}
                </StyledH2>
            </ModalHeader>
            <MenuWrapper
                rowData={rowData}
                oneShop={oneShop}
                setDataIsUpdated={setDataIsUpdated}
                salesModesData={rawSalesModes}
            />
            <PrinterFooter
                rowData={rowData}
                resetStore={resetStore}
                setDataIsUpdated={setDataIsUpdated}
            />
        </Modal>
    );
}
